import { useIncidentDetail } from "core/components/JianDetail/hooks/useIncidentDetail";
import { enumTranslator } from "./enumTranslator";

export type IncidentDetail = ReturnType<
  typeof useIncidentDetailForUbe
>['incidentInfo'];
export type IncidentDetailEmsTeam = ReturnType<
  typeof useIncidentDetailForUbe
>['emsTeamInfo'];
export type IncidentDetailPatients = ReturnType<
  typeof useIncidentDetailForUbe
>['patients'];
export type IncidentDetailPatient = ReturnType<
  typeof useIncidentDetailForUbe
>['patients'][number];
export type PatientTimeSeries = ReturnType<
  typeof useIncidentDetailForUbe
>['patients'][number]['timeSeries'];
export type ActivityRecordPdf = ReturnType<
  typeof useIncidentDetailForUbe
>['patients'][number]['activityRecordPdf'][number];

export const useIncidentDetailForUbe = () => {
    const {
        incidentDetailData,
      } = useIncidentDetail();
    
      const { incidentInfo, emsTeamInfo, patientInfo: patients } = enumTranslator(incidentDetailData);

      return {
        incidentInfo,
        emsTeamInfo,
        patients,
      };
};